/**
 * Encaixe para ações de página que nascem dentro do conteúdo de uma aba mas
 * devem aparecer na linha da própria barra de abas (ex.: "Reiniciar"). A página
 * renderiza `<LinhaAbas>` em volta do `TabsList`; quem está dentro da aba usa
 * `useSlotAcoes()` e desenha por portal. Sem encaixe, a ação fica no lugar.
 */

import * as React from "react";

const SlotAcoesContext = React.createContext<HTMLElement | null>(null);

export const useSlotAcoes = () => React.useContext(SlotAcoesContext);

/** Envolve as abas: a linha do `TabsList` ganha um encaixe à direita. */
export function ComSlotAcoes({
  abas,
  children,
}: {
  /** O `TabsList` da página. */
  abas: React.ReactNode;
  /** O restante do `Tabs` (os `TabsContent`). */
  children: React.ReactNode;
}) {
  const [slot, setSlot] = React.useState<HTMLDivElement | null>(null);
  return (
    <SlotAcoesContext.Provider value={slot}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        {abas}
        <div ref={setSlot} className="nao-imprimir flex items-center gap-3 empty:hidden" />
      </div>
      {children}
    </SlotAcoesContext.Provider>
  );
}
